import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import { Routes, useMatch, Link, useLocation, Route } from "react-router-dom";
import AllPools from "./AllPools";
import NewPool from "./NewPool";
import RolePermissionLandingPage from "../../../../RolePermissionLandingPage";

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
  title: {
    textAlign: "center",
  },
});

const Pool = ({ isAdmin }) => {
  const classes = useStyles();
  const [value, setValue] = useState(location.pathname);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <Paper className={classes.root}>
        <Typography variant="h5" className={classes.title}>
          Pool
        </Typography>
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="warning"
          centered
        >
          <Tab
            label="Manage"
            component={Link}
            to={"manage"}
            value={`/pool/manage`}
          />

          <Tab label="New" component={Link} to={"new"} value={`/pool/new`} />
        </Tabs>
      </Paper>
      <Routes>
        <Route path={"manage"} element={<Manage isAdmin={isAdmin} />} />
        <Route path={"new"} element={<New isAdmin={isAdmin} />} />
      </Routes>
    </>
  );

  function Manage({ isAdmin }) {
    return <AllPools isAdmin={isAdmin} />;
  }

  function New({ isAdmin }) {
    return isAdmin ? <NewPool /> : <RolePermissionLandingPage />;
  }
};

export default Pool;
